import { create } from 'zustand';
import { db, auth } from '../lib/firebase';
import {
    collection,
    query,
    where,
    orderBy,
    onSnapshot
} from 'firebase/firestore';
import { NodeService } from '../services/NodeService';

const useNodeStore = create((set, get) => ({
    nodes: [],
    loading: false,
    error: null,
    unsubscribeNodes: null,

    subscribeToNodes: () => {
        // Cleanup old listener
        const oldUnsub = get().unsubscribeNodes;
        if (oldUnsub) {
            oldUnsub();
            set({ unsubscribeNodes: null });
        }

        const user = auth.currentUser;
        if (!user) {
            // Log for debugging race conditions
            console.warn("[useNodeStore] subscribeToNodes called but currentUser is null (auth not ready yet)");
            set({ nodes: [], loading: false });
            return null;
        }

        set({ loading: true, error: null });

        const q = query(
            collection(db, 'nodes'),
            where('members', 'array-contains', user.uid)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            let nodes = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            // Client-side Sort
            nodes.sort((a, b) => {
                const tA = a.updatedAt?.seconds || 0;
                const tB = b.updatedAt?.seconds || 0;
                return tB - tA;
            });

            set({ nodes, loading: false });
        }, (err) => {
            console.error("Nodes subscription error:", err);
            set({ error: err.message, loading: false });
        });

        set({ unsubscribeNodes: unsubscribe });
        return unsubscribe;
    },

    createNode: async (title, parentId = null, settings = {}, members = []) => {
        try {
            const user = auth.currentUser;
            if (!user) throw new Error("No user logged in");
            await NodeService.createNode(user.uid, title, parentId, settings, members);
        } catch (err) {
            console.error("Create node error:", err);
            throw err;
        }
    }
}));

export default useNodeStore;
